import React, {Component} from "react";
import {Layout,Table, Divider, Modal, Form, Input, Button, Select, message} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './IllQuestion.less'
import '../../assets/css/admin.less'
import {
    reqCaseDetail,
    reqDeleteIllQuestion,
    reqIllCaseList,
    reqUpload
} from "../../api";

const {Content} = Layout;
const {TextArea} = Input;
const {Option} = Select;

/**
 * 病例考核路由组件
 */
class IllQuestion extends Component {

    state = {
        illCaseList:[],
        illQuestionList:[],
        selectValue:'',
        ModalText:'',
        visible:false,
        illQuestion:{},
        deleteVisible:false,
        imgId:'',
        illId:'',
        illTitle:'',
        total:0,
        deleteId:'',
        deleteName:'',
        selectedRowKeys: []
    };

    getIllCaseList = async (data) =>{
        const result = await reqIllCaseList(data);
        if(result.code === '000000') {
            this.setState({
                illCaseList:result.data.rows
            })
        }else {
            message.error(result.msg);
        }
    };

    getIllQuestionList = async (id) =>{
        const result = await reqCaseDetail(id);
        if(result.code === '000000') {
            this.setState({
                illQuestionList:result.data.questions,
                illTitle:result.data.title
            });
            if(result.data.questions!=='undefined'&&result.data.questions){
                this.setState({
                    total:result.data.questions.length
                });
            }else {
                this.setState({
                    total:0
                });
            }
        }else {
            message.error(result.msg);
        }
    };

    EditIll = (record,type) => {
        sessionStorage.setItem("illId",this.state.illId);
        if(type==='new'){
            sessionStorage.setItem("caseId","none");
        }else {
            sessionStorage.setItem("caseId",record.id);
        }
        this.props.history.push("/illEdit");
    };

    showDeleteModal =(record,type)=> {
        if(type==='删除') {
            this.setState({
                deleteId:record.id,
                deleteName:record.question,
                deleteVisible:true
            })
        }else {
            if(this.state.deleteId===''){
                message.info("没有选中行");
            }else {
                this.setState({
                    deleteVisible:true
                })
            }
        }
    };

    deleteIllQuestion = async(ids) => {
        const result = await reqDeleteIllQuestion(this.state.illId,ids);
        if(result.code==='000000'){
            message.success("作废成功");
            this.getIllQuestionList(this.state.illId);
            this.handleCancel();
        }
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText:'新增试题',
            illQuestion:{}
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible:false,
            imgId:'',
            deleteId:'',
            deleteName:'',
            selectedRowKeys:[]
        });
    };

    imgClick =()=> {
        document.getElementById("upload").click();
    };

    inputImg =async(e)=> {
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        const result = await reqUpload(data);
        this.setState({
            imgId:result.data
        });
    };

    componentDidMount = async() => {
        let id = sessionStorage.getItem("illId");
        this.setState({
            illId:id
        });
        this.getIllQuestionList(id);
        this.getIllCaseList({
            size:100,
            page:1
        });
        document.getElementsByClassName("ant-menu-item")[3].click();
        sessionStorage.clear();
        sessionStorage.setItem("illId",id);
        sessionStorage.setItem("caseTo","illQuestion");
        document.getElementsByClassName("ant-menu-item")[4].style.setProperty("display", "block");
        document.getElementsByClassName("ant-menu-item")[5].style.setProperty("color", "#12c4ed");
        document.getElementsByClassName("ant-menu-item")[5].style.setProperty("display", "block");
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render (){

        const {getFieldDecorator} = this.props.form;

        const { selectedRowKeys,illQuestionList,ModalText,total,visible,illQuestion,deleteVisible,deleteName,illCaseList,illTitle,deleteId} = this.state;

        const columns = [
        {
            title: '编号',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '所属病例',
            dataIndex: 'illTitle',
            key:'illTitle',
            render: (text, record) => (
                <span>{illTitle}</span>
            ),
        },
        {
            title:'类型',
            dataIndex:'questionType',
            key:'questionType'
        },
        {
            title:'题目',
            dataIndex:'question',
            key:'question'
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => (
                <span>
                    <a onClick={this.EditIll.bind(this,record,"edit")}>编辑</a>
                    <Divider type="vertical" />
                    <a onClick={this.showDeleteModal.bind(this,record,'删除')}>作废</a>
                </span>
            ),
        },
    ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].question)
                }
                this.setState({
                    deleteId:selectedRowKeys.toString(),
                    deleteName:name.toString(),
                    selectedRowKeys:selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right'>
                            <div className='table_search'>
                                <Button className='batch_delete' onClick={this.showDeleteModal.bind(this,deleteId,'批量删除')}>批量作废</Button>
                                <Button className='add_class' onClick={this.EditIll.bind(this,{},"new")}>新增试题</Button>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                   dataSource={illQuestionList} rowKey={illQuestionList => illQuestionList.id}/>
                                   <div className='page_footer'>共{total}条记录</div>
                        </div>
                        <Modal className='illQuestion_modal' title={ModalText} visible={visible} onCancel={this.handleCancel}
                               footer={null} destroyOnClose='true'>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue:illQuestion.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label={'病例'}>
                                    {getFieldDecorator('illId', {
                                        initialValue:illQuestion.illId,
                                        rules: [{ required: true, message: '请选择病例!' }],
                                    })(
                                        <Select>
                                            {
                                                illCaseList&&illCaseList.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.title}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label={'题干'}>
                                    {getFieldDecorator('question', {
                                        initialValue:illQuestion.question,
                                        rules: [{required: true, message: '请输入题干!'}],
                                    })(<Input />)}
                                </Form.Item>
                                <Form.Item label={'题型分类'}>
                                    {getFieldDecorator('questionType', {
                                        rules: [{ required: true, message: '请选择题型分类!' }],
                                        initialValue:illQuestion.questionType
                                    })(
                                        <Select>
                                            <Option key={"A"} value={"A"}>A型题</Option>
                                            <Option key={"B"} value={"B"}>B型题</Option>
                                            <Option key={"X"} value={"X"}>X型题</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label={'正确答案'}>
                                    {getFieldDecorator('correctAnswer', {
                                        initialValue:illQuestion.answer,
                                        rules: [{required: true, message: '请输入正确答案!'}],
                                    })(<Input placeholder={'如:A（多选请用|分开，如A|C）'}/>)}
                                </Form.Item>
                                <Form.Item label="选项">
                                    {getFieldDecorator('options', {
                                        initialValue:illQuestion.options,
                                        rules: [{required: true, message: '请输入选项!'}],
                                    })(<TextArea rows={4} placeholder={'请输入选项，一行一个选项'}/>)}
                                </Form.Item>
                                <Form.Item label='题干图片'>
                                    <div className='img_list'>
                                        <img className='upload_img' src={this.state.imgId===''?require("../../assets/images/upload_img.png"):(global.constant.uploadImage+this.state.imgId)} onClick={this.imgClick.bind(this)}/>
                                        <Input className='upload_img' name="file" accept="image/*" id="upload" type="file" style={{opacity:0,display:'none'}} onChange={this.inputImg.bind(this)}/>
                                    </div>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        确定
                                    </Button>
                                    <Button onClick={this.handleCancel}>
                                        取消
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="确定作废吗？"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteIllQuestion.bind(this,deleteId)}
                            onCancel={this.handleCancel}>
                            <div>{deleteName}</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapIllCase = Form.create()(IllQuestion);
export default WrapIllCase;